module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_01_american-village-257d6118859899b3dd32bd1cf16476c9.jpg";